import { lens27v59dqa1oc3r as lens } from '../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function lensPath(_this__u8e3s4, path) {
  var tmp = (it) => path.get_wei43m_k$(it);
  return _this__u8e3s4.lens_u4wb4z_k$(tmp, (o, it) => path.set_iuhvb1_k$(o, it));
}
function lensPath_0(_this__u8e3s4, path) {
  var tmp = (it) => path.get_wei43m_k$(it);
  return _this__u8e3s4.lens_u4wb4z_k$(tmp, (o, it) => path.set_iuhvb1_k$(o, it));
}
function lensPath_1(_this__u8e3s4, path) {
  return lens(_this__u8e3s4, (it) => path.get_wei43m_k$(it));
}
//region block: exports
export {
  lensPath as lensPath21i5dxhjzuxep,
  lensPath_1 as lensPathqivb610kygo1,
  lensPath_0 as lensPath3fz41zcs9wh0z,
};
//endregion

//# sourceMappingURL=MutableReactive.lens.DataClassPath.mjs.map
